import dayjs from 'dayjs';

// Fun Coin 服務結束日期
export const FUN_COIN_SERVICE_END_DATE = '2026-02-28T23:59:59';

// Fun Coin 服務紀錄檢視延長日期
export const FUN_COIN_SERVICE_EXTEND_DATE = '2026-09-30T23:59:59';

// KOL 停止 Fun Coin 服務白名單
export const WHITE_LIST_KOL: { id: number; endDate: string }[] = [
  {
    id: 979797,
    endDate: '2026-07-31T23:59:59'
  },
  {
    id: 147517,
    endDate: '2026-06-30T23:59:59'
  },
  {
    id: 972004,
    endDate: '2026-06-30T23:59:59'
  }
] as const;

export function useFunCoin() {
  const userStore = useUserStore();

  const inKolWhiteList = computed<{ id: number; endDate: string } | undefined>(() => {
    return WHITE_LIST_KOL.find((item) => item.id === userStore.userData.memberId);
  });

  /**
   * 是否停止 Fun Coin 服務
   * @param endDate - 停止日期
   * @remarks KOL 白名單使用個別結束日期，其餘在 2026-02-28 23:59:59 之後停止
   */
  const isFunCoinServiceStopped = (endDate: string = FUN_COIN_SERVICE_END_DATE): boolean => {
    const currentDate = dayjs();

    // 檢查 KOL 白名單個別的結束日期
    const kolWhiteListItem = inKolWhiteList.value;
    if (kolWhiteListItem) {
      return currentDate.isAfter(dayjs(kolWhiteListItem.endDate));
    }

    // 其餘統一 2026-02-28 之後停止服務
    return currentDate.isAfter(dayjs(endDate));
  };

  /**
   * 是否可查看 Fun Coin 紀錄
   * @remarks 檢視 Fun Coin 紀錄至 2026/09/30 止
   */
  const isDisableFunCoinRecord = (): boolean => {
    const currentDate = dayjs();
    return currentDate.isAfter(dayjs(FUN_COIN_SERVICE_EXTEND_DATE));
  };

  return {
    inKolWhiteList,
    isFunCoinServiceStopped,
    isDisableFunCoinRecord
  };
}
